module.exports = __webpack_public_path__ + "static/media/Murmuratto_Template_Category.0a371303.csv";